import axios, { AxiosResponse } from 'axios';
import 'es6-promise/auto';
import { getUserData, logoutUser} from '../services/loginService'; 
/* Local */
//let baseURL = ' http://127.0.0.1:5000/';

/* Stage */
//let baseURL = 'http://ec2-52-12-149-57.us-west-2.compute.amazonaws.com/';
// let baseURL = 'http://stage-api.argosems.com/';

/* Production */
let baseURL = 'https://prod-api.argosems.com/';

/* OLD Production */
//let baseURL = 'https://backargos.com/'
// baseURL: 'https://argosbackend.com/',

export async function getDev(url: string, data: Object = {}): Promise<AxiosResponse> {
    const axiosInstance = axios.create({ 
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/json',
            Auth: (getUserData() || '').token,
        },
    });
    const response = await axiosInstance.get(url, {
    });
    if (response.data.status === 'valid') {
        return response;
    } else if(response.data.status === 'invalid' && response.data.message==='Unauthorized access') {
        logoutUser(null);  
        location.reload(true); 
    } else {
        throw new Error(JSON.stringify(response.data));
    }
}

export async function postDev(url: string, data: Object = {}): Promise<AxiosResponse> {
    const axiosInstance = axios.create({ 
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/json',
            Auth: (getUserData() || '').token,
        },
    });

    const response = await axiosInstance.post(url, data);
    if (response.data.status === 'valid') {
        return response;
    } else if(response.data.status === 'invalid' && response.data.message==='Unauthorized access') {
        logoutUser(this.props.history); 
        location.reload(true); 
    } else {
        //throw new Error(JSON.stringify(response.data.message));
        throw new Error( (response.data.message) );
    }
}

export async function putDev(url, data) {
    const axiosInstance = axios.create({ 
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/json',
            Auth: (getUserData() || '').token,
        },
    });

    const response = await axiosInstance.put(url, data);
    if (response.data.status === 'valid') {
        return response;
    } else if(response.data.status === 'invalid' && response.data.message==='Unauthorized access') {
        logoutUser(this.props.history); 
        location.reload(true); 
    } else {
        throw new Error(JSON.stringify(response.data));
    }
}

export async function delDev(url: string) {
    const axiosInstance = axios.create({ 
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/json',
            Auth: (getUserData() || '').token,
        },
    });
    const response = await axiosInstance.delete(url);
    if (response.data.status === 'valid') {
        return response;
    } else if(response.data.status === 'invalid' && response.data.message==='Unauthorized access') {
        logoutUser(this.props.history); 
        location.reload(true); 
    } else {
        throw new Error(JSON.stringify(response.data));
    }
}

export async function updatePasswordDev(url: string) {
    const axiosInstance = axios.create({ 
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/json',
            Auth: (getUserData() || '').token,
        },
    });
    const response = await axiosInstance.put(url);
    if (response.data.status === 'valid') {
        return response;
    } else {
        throw new Error(JSON.stringify(response.data));
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/HTTPDev.ts